import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuswertungLayouts from './auswertung-layouts.reducer';

export const selectAuswertungLayoutsState =
  createFeatureSelector<fromAuswertungLayouts.State>(
    fromAuswertungLayouts.auswertungLayoutsFeatureKey,
  );

export const selectMonatsauswertungLayouts = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.monatsauswertungLayouts,
);

export const selectMonatsauswertungLayoutsLoading = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.monatsauswertungLayouts === undefined,
);

export const selectMonatsauswertungLayoutsSpalten = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.monatsauswertungSpalten,
);

export const selectMonatsauswertungLayoutsSpaltenLoading = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.monatsauswertungSpalten === undefined,
);

export const selectAggregierteAuswertungenLayouts = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.aggregierteAuswertungenLayouts,
);

export const selectAggregierteAuswertungenLayoutsLoading = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.aggregierteAuswertungenLayouts === undefined,
);

export const selectAggregierteAuswertungenSpalten = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.aggregierteAuswertungenSpalten,
);

export const selectAggregierteAuswertungenSpaltenLoading = createSelector(
  selectAuswertungLayoutsState,
  (state) => state.aggregierteAuswertungenSpalten === undefined,
);
